import styled from 'styled-components';

export const HoverShadow = styled('div')`
  &:hover {
    box-shadow: 0px 4px 16px ${({ theme }) => theme.color.blackRGBA(0.25)};
  }
`;
